import {BaseAppModel} from "./AppModel";

export default class DeviceMqtt extends BaseAppModel<DeviceMqtt> {
    host!: string
    port!: number
    username!: string
    password!: string
    clientId!: string
    appClientId!: string
    retained!: boolean
}